import { defineMessages } from 'react-intl'

const translations = defineMessages({
  headline: {
    defaultMessage: 'My Machines',
    id: 'global.account.link.my_machines'
  },
  noMachines: {
    defaultMessage: `You don't have any registered machine, you can add one from the machines management page by clicking on link below.`,
    id: 'msp.account.overview.no_machines'
  }
})

export default translations
